import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icw-x__clip0_12621_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5222 10.7714L19.4785 4h-1.4114l-5.1719 5.87954L8.76437 4H4l6.2466 8.8909L4 19.9918h1.41155l5.46165-6.209 4.3624 6.209H20l-6.4782-9.2204h.0004zm-1.9333 2.1978l-.6329-.8853-5.03585-7.04469H8.0882l4.064 5.68529.6329.8853 5.2826 7.39h-2.168l-4.3108-6.0302v-.0004z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icw-x__clip0_12621_2262"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  }))));
});